<template>
   <div class="add-mcq-element container-fluid"> 
        <div class="row margin-bottom-2Perc" v-for="currentOption in totalOptions" :key="currentOption"> 
          <div class="col-md-1 col-lg-1 margin-top-0Point7Perc" v-if="getSelectedMCQTypeValue === 0">
            <input type="radio" value="true" v-model="tempOptionArr[currentOption - 1].IsSelected" @click="selectedSingleChoiceOption($event,currentOption)">
          </div>
          <div class="col-md-1 col-lg-1 margin-top-0Point7Perc" v-if="getSelectedMCQTypeValue === 1">
            <input type="checkbox" value="true" v-model="tempOptionArr[currentOption - 1].IsSelected">
          </div>
          <div class="col-md-1 col-lg-1 font-weight-bold font-color-blue font-size-21px margin-top-0Point5Perc">
            {{tempOptionArr[currentOption - 1].OptionNo}}
            <!-- {{alphabetArr[currentOption-1]}} -->
          </div>
          <div class="col-md-8 col-lg-8">
            <div class="form-group">
              <!-- <input type="text" class="form-control" v-model="tempOptionArr[currentOption - 1].OptionText" maxlength="1024"> -->
              <textarea class="form-control" rows="2" v-model="tempOptionArr[currentOption - 1].OptionText" maxlength="1024"></textarea>
            </div>
          </div>
          <div class="col-md-1 col-lg-1">
            <span class="glyphicon glyphicon-plus-sign cursor-pointer" @click="addNewOption" v-if="tempOptionArr[currentOption - 1].AllowToAddNextOption"></span>            
          </div>
          <div class="col-md-1 col-lg-1">
            <span class="glyphicon glyphicon-minus-sign cursor-pointer" @click="removeOption($event,currentOption)"></span>
          </div>  
        </div> 
        <alert-box v-if="showAlertDialog" v-bind:errorMsg="errorMsg" @showAlertBox="updateShowAlertDialogFlag"></alert-box>
        <confirmation-alert v-if="showConfirmationBox" v-bind:dataObj="null" v-bind:prefixString="prefixString" v-bind:postfixString="postString" @showConfirmationBox="updateShowConfirmationAlertFlag" @userConfirmation="resetAllCorrectOption"></confirmation-alert>
  </div>
</template>
<script>
import { constants } from '@/utils/constants'
import AlertBox from '@/components/AlertOverlay'
import ConfirmationOverlay from '@/components/ConfirmationOverlay'
import { dmAdminUtils } from '@/utils/dmAdminUtils'
export default {
  props: ['selectedMCQType', 'mcqBtnClicked', 'elementObj'],
  name: 'add-mcq-element',
  created () {
    this.addOptionObjOnInitialLoad()
    // this.setOptionNo()
  },
  data: function () {
    return {
      showAlertDialog: false,
      errorMsg: '',
      tempOptionArr: [],
      totalOptions: 1,
      alphabetArr: ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z'],
      mcqType: 0,
      showConfirmationBox: false,
      prefixString: 'Saved correct option(s) will be lost.',
      postString: '\nAre you sure you want to change question type?'
    }
  },
  components: {
    'confirmation-alert': ConfirmationOverlay,
    'alert-box': AlertBox
  },
  methods: {
    addOptionObjOnInitialLoad: function () {
      // AK: create new optionObj
      var optionObj = {
        OptionNo: this.alphabetArr[this.totalOptions - 1],
        OptionText: '',
        SubOptions: '',
        CorrectSubOption: '',
        IsSelected: false,
        AllowToAddNextOption: true
      }
      // AK: add it to tempOptionArr
      this.tempOptionArr.push(optionObj)
      console.log('this.tempOptionArr >>>> ' + JSON.stringify(this.tempOptionArr))
    },
    addNewOption: function () {
      if (this.tempOptionArr[this.totalOptions - 1].OptionText.trim().length === 0) {
        this.showAlertDialog = true
        this.errorMsg = 'To add next option, please fill in \'' + this.alphabetArr[this.totalOptions - 1] + '\' option text first.'
        return
      }
      if (this.totalOptions !== 26) {
        // AK: Remove allow to add next option from current optionObj
        this.tempOptionArr[this.totalOptions - 1].AllowToAddNextOption = false
        // AK: Added new object
        this.totalOptions += 1
        this.addOptionObjOnInitialLoad()
      } else {
        this.showAlertDialog = true
        this.errorMsg = 'Option limit exceeded.'
      }
    },
    removeOption: function (event, currentIndex) {
      if (this.totalOptions !== 1) {
        if (currentIndex === this.totalOptions) {
          // AK: IF user removed last option then show Add button previous option
          this.tempOptionArr[currentIndex - 2].AllowToAddNextOption = true
        }
        // AK: Remove given option from Array
        this.udpatedTempArrAfterDelete(currentIndex - 1)
        this.totalOptions -= 1
      } else {
        this.showAlertDialog = true
        this.errorMsg = 'To create a MCQ, at least one option is required.'
      }
    },
    updateShowAlertDialogFlag (value) {
      this.showAlertDialog = value
    },
    udpatedTempArrAfterDelete: function (indexToRemove) {
      this.tempOptionArr.splice(indexToRemove, 1)
      // AK: After removing option, re-arrange the OptionNo again
      this.reArrangeOptionNo()
      console.log('After Delete >>> ' + JSON.stringify(this.tempOptionArr))
    },
    reArrangeOptionNo: function () {
      for (var i = 0; i < this.tempOptionArr.length; i++) {
        this.tempOptionArr[i].OptionNo = this.alphabetArr[i]
      }
      console.log('After Re-arranging Option Numbers >>> ' + JSON.stringify(this.tempOptionArr))
    },
    updateShowConfirmationAlertFlag (value) {
      // AK: Used when user pressed close button of confrimation overlay
      this.showConfirmationBox = value
    },
    resetAllCorrectOption: function (value) {
      // AK: If user migrate from previous select question type to new, reset all correct option data
      if (value) {
        // AK: Assign new type
        this.mcqType = this.selectedMCQType
        for (var i = 0; i < this.tempOptionArr.length; i++) {
          this.tempOptionArr[i].IsSelected = false
        }
      }
      console.log('After resetAllCorrectOption >>> ' + JSON.stringify(this.tempOptionArr))
    },
    selectedSingleChoiceOption: function (event, currentOption) {
      // AK: Reset all option values except selected
      for (var i = 0; i < this.tempOptionArr.length; i++) {
        if (i === (currentOption - 1)) {
          this.tempOptionArr[i].IsSelected = true
        } else {
          this.tempOptionArr[i].IsSelected = false
        }
      }
      console.log('After selectedSingleChoiceOption >>> ' + JSON.stringify(this.tempOptionArr))
    },
    selectedCorrectAnsCount: function () {
      var totalCorrectAns = 0
      for (var i = 0; i < this.tempOptionArr.length; i++) {
        if (this.tempOptionArr[i].IsSelected) {
          ++totalCorrectAns
        }
      }
      return totalCorrectAns
    }
  },
  computed: {
    getSelectedMCQTypeValue: {
      get: function () {
        // AK: First Check user is selected Different Answer than current is yes then reset all correct option values
        if (this.mcqType !== this.selectedMCQType) {
          this.resetAllCorrectOption(true)
        }
        this.mcqType = this.selectedMCQType
        return this.selectedMCQType
      }
    },
    VideoURLValue: {
      get: function () {
        return this.elementObj.MCQItem.ExplanationVideoUrl
      },
      set: function (newValue) {
        this.elementObj.MCQItem.ExplanationVideoUrl = newValue
      }
    },
    HDVideoURLValue: {
      get: function () {
        return this.elementObj.MCQItem.HDVideoUrl
      },
      set: function (newValue) {
        this.elementObj.MCQItem.HDVideoUrl = newValue
      }
    },
    LowVideoURLValue: {
      get: function () {
        return this.elementObj.MCQItem.LowQualityVideoUrl
      },
      set: function (newValue) {
        this.elementObj.MCQItem.LowQualityVideoUrl = newValue
      }
    }
  },
  watch: {
    mcqBtnClicked: function () {
      var regex = /^(?:([0-5]?\d):)?([0-5]?\d)$/g
      if (this.elementObj.Title.trim().length === 0) {
        this.errorMsg = 'Title can\'t be empty.'
        this.showAlertDialog = true
        this.$emit('addOptions', false)
      } else if ((this.elementObj.Duration.trim().length !== 0 && this.elementObj.Duration.indexOf(':') === -1)) {
        this.showAlertDialog = true
        this.errorMsg = 'Duration format should be MM:SS.'
        this.$emit('addOptions', false)
      } else if (this.elementObj.IncludeInProgress && this.elementObj.Duration.trim().length > 0 && !regex.test(this.elementObj.Duration)) {
        this.showAlertDialog = true
        this.errorMsg = 'Please enter a valid duration.'
        this.$emit('addOptions', false)
      } else if (this.elementObj.MCQItem.QuestionText.trim().length === 0) {
        this.errorMsg = 'Question text can\'t be empty.'
        this.showAlertDialog = true
        this.$emit('addOptions', false)
      } else if (this.LowVideoURLValue && this.LowVideoURLValue.trim().length !== 0 && (!dmAdminUtils.isValidUrl(this.LowVideoURLValue.trim()) || !dmAdminUtils.checkForVideoFileExtesion(this.LowVideoURLValue.trim()))) {
        this.showAlertDialog = true
        this.errorMsg = 'Please add valid Low Quality Video url.'
        this.$emit('addOptions', false)
      } else if (this.VideoURLValue && this.VideoURLValue.trim().length !== 0 && (!dmAdminUtils.isValidUrl(this.VideoURLValue.trim()) || !dmAdminUtils.checkForVideoFileExtesion(this.VideoURLValue.trim()))) {
        this.showAlertDialog = true
        this.errorMsg = 'Please add valid Auto Quality Video url.'
        this.$emit('addOptions', false)
      } else if (this.HDVideoURLValue && this.HDVideoURLValue.trim().length !== 0 && (!dmAdminUtils.isValidUrl(this.HDVideoURLValue.trim()) || !dmAdminUtils.checkForVideoFileExtesion(this.HDVideoURLValue.trim()))) {
        this.showAlertDialog = true
        this.errorMsg = 'Please add valid High Quality Video url.'
        this.$emit('addOptions', false)
      } else {
        // AK: Check weather last option filled or not
        if (this.tempOptionArr[this.totalOptions - 1].OptionText.trim().length === 0) {
          this.showAlertDialog = true
          this.errorMsg = 'Please fill in \'' + this.alphabetArr[this.totalOptions - 1] + '\' option text'
          if (this.totalOptions !== 1) {
            this.errorMsg += ' or remove it.'
          } else {
            this.errorMsg += '.'
          }
          this.$emit('addOptions', false)
        } else {
          var totalCorrectAnsMarkedCount = this.selectedCorrectAnsCount()
          switch (this.getSelectedMCQTypeValue) {
            case constants.Question_Type.Single_Answer:
              if (totalCorrectAnsMarkedCount > 0) {
                this.$store.state.createMcqOptions = this.tempOptionArr
                this.$emit('addOptions', true)
              } else {
                this.errorMsg = 'Please select at least one correct option to create \'Single Answer\' type MCQ.'
                this.showAlertDialog = true
                this.$emit('addOptions', false)
              }
              break
            case constants.Question_Type.Multiple_Answers:
              // AK: check than one answer selected or not?
              if (totalCorrectAnsMarkedCount > 1) {
                this.$store.state.createMcqOptions = this.tempOptionArr
                this.$emit('addOptions', true)
              } else {
                this.errorMsg = 'Please select more than one correct options to create \'Multiple Answer\' type MCQ.'
                this.showAlertDialog = true
                this.$emit('addOptions', false)
              }
              break
          }
        }
      }
    }
  }
}
</script>

<style scoped>
.animationload {
  height: 100%;
  left: 0;
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 10000;
}
.osahanloading {
  animation: 1.5s linear 0s normal none infinite running osahanloading;
  background: #fed37f none repeat scroll 0 0;
  border-radius: 50px;
  height: 50px;
  left: 50%;
  margin-left: -25px;
  margin-top: -25px;
  position: absolute;
  top: 50%;
  width: 50px;
}
.osahanloading::after {
  animation: 1.5s linear 0s normal none infinite running osahanloading_after;
  border-color: #85d6de transparent;
  border-radius: 80px;
  border-style: solid;
  border-width: 10px;
  content: "";
  height: 80px;
  left: -15px;
  position: absolute;
  top: -15px;
  width: 80px;
}
@keyframes osahanloading {
  0% {
    transform: rotate(0deg);
  }
  50% {
    background: #85d6de none repeat scroll 0 0;
    transform: rotate(180deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.white-BG {
  background-color: #ffffff;
}
.overlay-overall-width-100Perc {
  width: 100% !important;
}
.overlay-overall-width-0Perc {
  width: 0%;
}
.overlay {
  height: 100%;
  width: 0;
  position: fixed;
  z-index: 3;
  top: 0;
  left: 0;
  background-color: rgb(0, 0, 0);
  background-color: rgba(0, 0, 0, 0.75);
  overflow-x: hidden;
  /*transition: 0.5s;*/
}

.overlay-content {
  position: relative;
  top: 5%;
  width: 100%;
  text-align: center;
  margin-top: 30px;
}
.background-color-white {
  background-color: #ffffff !important;
}
.white-porition-overlay-width-80Perc {
  width: 80%;
}
.center-aligned-div {
  margin: 0 auto;
}

.overlay a {
  padding: 8px;
  text-decoration: none;
  font-size: 36px;
  color: #818181;
  display: block;
  transition: 0.3s;
}

.overlay a:hover,
.overlay a:focus {
  color: #f1f1f1;
}

.overlay .closebtn {
  position: absolute;
  top: 20px;
  right: 45px;
  font-size: 60px;
}
@media screen and (max-height: 450px) {
  .overlay a {
    font-size: 20px;
  }
  .overlay .closebtn {
    font-size: 40px;
    top: 15px;
    right: 35px;
  }
}
.close-text-font-style {
  color: #aaa;
  font-size: 30px;
}
.text-align-right {
  text-align: right;
}
.text-align-left {
  text-align: left !important;
}
.margin-right-2Perc {
  margin-right: 2%;
}
.width {
  width: 95%;
}
.create-lesson {
  overflow-y: hidden !important;
}
.background-gray {
  background-color: aqua;
}
.overflow-y-hidden {
  overflow-y: hidden !important;
}
.overflow-hidden {
  overflow: hidden;
}
.save-button-width {
  width: 60% !important;
}
.padding-Top-2Perc {
  padding-top: 2%;
}
.padding-Top-3Perc {
  padding-top: 3%;
}
.font-size-1-3vw {
  font-size: 1.3vw;
}
.font-size-21px {
  font-size: 21px;
}
.font-size-16px {
  font-size: 16px;
}
.text-align-left {
  text-align: left;
}
.input-group .icon-addon .form-control {
  border-radius: 0;
}

.icon-addon {
  position: relative;
  color: #555;
  display: block;
}

.icon-addon:after,
.icon-addon:before {
  display: table;
  content: " ";
}

.icon-addon:after {
  clear: both;
}

.icon-addon.addon-md .glyphicon,
.icon-addon .glyphicon,
.icon-addon.addon-md .fa,
.icon-addon .fa {
  position: absolute;
  z-index: 2;
  left: 10px;
  font-size: 14px;
  width: 20px;
  margin-left: -2.5px;
  text-align: center;
  padding: 8px 0;
  top: 1px;
}

.icon-addon.addon-lg .form-control {
  line-height: 1.33;
  height: 30px;
  border-radius: 15px;
  font-size: 13px;
  padding: 10px 16px 10px 40px;
}

.icon-addon.addon-sm .form-control {
  height: 30px;
  padding: 5px 10px 5px 28px;
  font-size: 12px;
  line-height: 1.5;
}

.icon-addon.addon-lg .fa,
.icon-addon.addon-lg .glyphicon {
  font-size: 14px;
  margin-left: 0;
  left: 11px;
  top: 0px;
}

.icon-addon.addon-md .form-control,
.icon-addon .form-control {
  padding-left: 30px;
  float: left;
  font-weight: normal;
}

.icon-addon.addon-sm .fa,
.icon-addon.addon-sm .glyphicon {
  margin-left: 0;
  font-size: 12px;
  left: 5px;
  top: -1px;
}

.icon-addon .form-control:focus + .glyphicon,
.icon-addon:hover .glyphicon,
.icon-addon .form-control:focus + .fa,
.icon-addon:hover .fa {
  color: #2580db;
}
.background-gray {
  background-color: #ddd;
}
.border-rounded {
  border-bottom-right-radius: 12.5%;
  border-top-left-radius: 12.5%;
  border-top-right-radius: 12.5%;
  border-bottom-left-radius: 12.5%;
}
.gray-border {
  border: 1px solid #aaa;
}
.lesson-box-border {
  border: 1px solid #dddddd;
}
.vertical-align {
  display: flex;
  align-items: center;
}
.center-align-div {
  margin: 0 auto;
}
.margin-left-3Perc {
  margin-left: 3% !important;
}
.switch {
  position: relative;
  display: inline-block;
  width: 60px;
  height: 30px;
}

.switch input {
  display: none;
}

.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}

.slider:before {
  position: absolute;
  content: "";
  height: 23px;
  width: 23px;
  left: 4px;
  bottom: 4px;
  background-color: white;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}

input:checked + .slider {
  background-color: #32cd32;
}

input:focus + .slider {
  box-shadow: 0 0 1px #32cd32;
}

input:checked + .slider:before {
  -webkit-transform: translateX(26px);
  -ms-transform: translateX(26px);
  transform: translateX(26px);
}

/* Rounded sliders */
.slider.round {
  border-radius: 34px;
}

.slider.round:before {
  border-radius: 50%;
}
.border-color-red {
  border: 1px solid red;
}
.border-color-yellow {
  border: 1px solid yellow;
}
.create-lesson-input-text-style {
  color: #34495e;
  font-size: 14px;
}
.padding-right-0Px {
  padding-right: 0px !important;
}
.margin-bottom-2Perc {
  margin-bottom: 2%;
}
.create-lesson-overlay-button-BG {
  background-color: #f39c12 !important;
  border: 1px solid #f39c12 !important;
}
.create-lesson-overlay-button-width {
  width: 20%;
}
.black-font-color {
  color: #000;
}
.cursor-pointer {
  cursor: pointer;
}
.close-img-width-height {
  width: 5%;
  height: 5%;
}
.margin-top-3Perc {
  margin-top: 3%;
}
.margin-top-0Point7Perc {
  margin-top: 0.7%;
}
.margin-top-0Point5Perc {
  margin-top: 0.5%;
}
.float-right {
  float: right;
}
.font-color-blue {
  color: #34495e;
}
.font-weight-bold {
  font-weight: bold;
}

.margin-right-3Perc {
  margin-right: 3%;
}
.margin-left-2Perc {
  margin-left: 2% !important;
}
.padding-bottom-1Perc {
  padding-bottom: 1%;
}
.bottom-border {
  border-bottom: 1px solid #ddd;
  width: 96%;
}
.font-wight-bold {
  font-weight: bold;
}
.create-element-overlay-course-title-font-styles {
  font-size: 14px;
  color: #34495e;
}
.create-element-overlay-module-title-font-styles {
  font-size: 20px;
  color: #34495e;
}
.margin-Top-1Point5Perc {
  padding-top: 1.5%;
}
.padding-left-4Point4 {
  padding-left: 4.4%;
}
.padding-right-0px{
  padding-right: 0px !important;
}
.padding-left-0px{
  padding-left: 0px !important;
}
.font-size-12px{
  font-size: 12px;
}
.glyphicon {
    font-size: 25px;
}
</style>


// WEBPACK FOOTER //
// src/components/AddMCQOption.vue